'use client';

import { ProgressProvider as BProgress } from '@bprogress/next/app';
export const Progress = () => {
  return <BProgress color='#619e22' height='4px' options={{
    showSpinner: false
  }} shallowRouting />;
};